import Component from '@glimmer/component'
import RouteTemplate from 'ember-route-template'
import type TeacherGuidesRoute from 'teacher-ui-client/subscription-type/quick-links/teacher-guides/route'
import { getTeacherGuidesViewModel } from 'teacher-ui-client/subscription-type/quick-links/contentful-view-models'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { t } from 'ember-intl'
import { TeacherGuideTile } from 'teacher-ui-client/components/teacher-guide-tile'

interface Signature {
  Args: {
    model: ModelFor<TeacherGuidesRoute>
  }
}

export class QuickLinksTeacherGuidesPage extends Component<Signature> {
  get teacherGuides() {
    return getTeacherGuidesViewModel(this.args.model.teacherGuides)
  }

  <template>
    <div class="mx-auto my-8 w-full px-8">

      <PageHeader>
        <:title>
          <h1>
            {{t "quickLinks.pageTitles.teacherGuides"}}
          </h1>
        </:title>
      </PageHeader>

      <div class="flex flex-wrap justify-center overflow-hidden">
        {{#each this.teacherGuides as |teacherGuide|}}

          <TeacherGuideTile
            class="m-2"
            @title={{teacherGuide.title}}
            @description={{teacherGuide.description}}
            @coverUrl={{teacherGuide.coverUrl}}
            @fileUrl={{teacherGuide.fileUrl}}
          />

        {{/each}}
      </div>

    </div>
  </template>
}

export default RouteTemplate(QuickLinksTeacherGuidesPage)
